import { useQuery } from "@tanstack/vue-query";

import { explorerApi } from "~/api/client";
import type { NexonLwBurnOverviewInfo } from "~/api/repository";

export const getBurnOverview = () => {
  return useQuery({
    queryKey: ["burnOverview"],
    queryFn: () =>
      explorerApi.lwController
        .getBurnOverview({ requestBody: {} })
        .then((res) => burnOverviewDto(res)),
  });
};

export type BurnOverviewView = {
  prevBurn: number;
  prevBurnStatus: "ACTUAL" | "ESTIMATED";
  qtdBurnProjection: number;
  quarterProgress: number;
  targetDate: Date;
  totalBurned: number;
  // 계산된 Quarter 정보
  currentQuarter: string;
  prevQuarter: string;
  quarterStartDate: Date;
};

const burnOverviewDto = (data: NexonLwBurnOverviewInfo): BurnOverviewView => {
  const targetTimestamp = Number(data.TARGET_DT);
  const targetDate = new Date(targetTimestamp * 1000);

  // Quarter 정보 계산
  const quarter = Math.ceil((targetDate.getMonth() + 1) / 3);
  const year = targetDate.getFullYear();

  // Quarter 시작일 계산
  const quarterStartMonth = (quarter - 1) * 3;
  const quarterStartDate = new Date(year, quarterStartMonth, 1);

  // 이전 Quarter 계산
  const prevQuarterNum = quarter === 1 ? 4 : quarter - 1;
  const prevYear = quarter === 1 ? year - 1 : year;

  return {
    prevBurn: Number(data.PREV_BURN),
    prevBurnStatus: data.PREV_BURN_STATUS,
    qtdBurnProjection: Number(data.QTD_BURN_PROJ),
    quarterProgress: Number(data.QUARTER_PROG),
    targetDate,
    totalBurned: Number(data.TOTAL_BURNED),
    currentQuarter: `Q${quarter} ${year}`,
    prevQuarter: `Q${prevQuarterNum} ${prevYear}`,
    quarterStartDate,
  };
};
